import { Fragment, ReactElement } from 'react';
import { Container, styled } from '@mui/material';
import { formatDate, ValueLabel, variables, mapRole, formatDateUTC } from '../common';
import { IStatusLegacy } from '.';
import { pathOr } from 'rambda';
import {
  map as lmap,
  compose as lcompose,
  compact as lcompact,
} from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const render = (properties: ValueLabel<string>[]) =>
  lcompose(
    fold(
      () => <Container maxWidth="lg">Empty</Container>,

      deaRegistrations => (
        <Article>
          {lmap<ValueLabel<string>, ReactElement>(({ value, label }) => (
            <h4 key={label}>
              <span>{label}</span>
            </h4>
          ))(properties)}

          {lmap<IStatusLegacy, ReactElement>(
            lcompose(
              ([a, b]) => <Fragment key={a.requestId}>{b}</Fragment>,
              ([a, b]) => [a, lcompact(b)],
              a => [
                a,
                [
                  ...lmap<ValueLabel<string>, ReactElement | undefined>(
                    ({ value }) => (
                      <SpanPV key={`${a.srNum}-${value}`}>
                        {show(a)(value)}
                      </SpanPV>
                    )
                  )(properties),
                ],
              ]
            )
          )(deaRegistrations)}
        </Article>
      )
    ),

    (requests: IStatusLegacy[]) =>
      requests.length === 0 ? left(requests) : right(requests)
  );

const show = (a: IStatusLegacy) => (prop: string) =>
  prop === 'requestType'
    ? 'Revoke'
    : prop === 'role'
    ? flow(pathOr('', prop), mapRole)(a)
    : prop === 'subscriberInfo'
    ? `${a.firstName} ${a.middleInitial} ${a.lastName}`
    : prop === 'createdAt'
    ? flow(pathOr('', prop), formatDateUTC)(a)
    : flow(pathOr(void 0, prop))(a);

const Article = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(10, auto) ',
    gridAutoRows: 'minmax(auto, 5em)',

    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));

const SpanPV = styled('span')(({ theme }) => ({
  overflow: 'auto',
}));
